(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["autoplay-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('autoplay-carousel')) {
    customElements.define(
      'autoplay-carousel',
      class AutoplayCarousel extends HTMLElement {
        connectedCallback() {
          requestAnimationFrame(() => this.#setup());
          window.addEventListener('pageshow', this.#handlePageShow);
        }

        disconnectedCallback() {
          window.removeEventListener('pageshow', this.#handlePageShow);
        }

        #handlePageShow = () => {
          requestAnimationFrame(() => {
            for (const scroller of this.querySelectorAll('slideshow-slides')) {
              if (scroller.scrollLeft > 0) scroller.scrollTo({ left: 0, behavior: 'instant' });
            }
          });
        };

        #setup() {
          const slideshow = this.querySelector('slideshow-component');
          if (!slideshow) return;

          slideshow.setAttribute('infinite', '');
          this.querySelector('slideshow-container')?.removeAttribute('animate-arrows');
          if (typeof slideshow.current === 'number') slideshow.current = slideshow.current;

          const interval = this.getAttribute('autoplay-interval');
          if (!interval) return;

          slideshow.setAttribute('autoplay', interval);
          this.addEventListener('focusin', () => slideshow.pause?.());
          this.addEventListener('focusout', () => slideshow.play?.());
          slideshow.resume?.();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
